module.exports = __webpack_public_path__ + "img/MX-B055046B-BS-HQ.0f00ad9f.png";